import { render, staticRenderFns } from "./ZbonList.vue?vue&type=template&id=220c9938"
import script from "./ZbonList.vue?vue&type=script&lang=js"
export * from "./ZbonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports